import i18next from 'i18next';

i18next.addResources('es', 'map', {
  projects: 'Proyectos y Acciones',
  home: 'Inicio',
  maps: 'Mapas',
  byTerritory: 'Proyectos y Acciones por Territorio'
});

i18next.addResources('en', 'map', {
  projects: 'Projects and Actions',
  home: 'Home',
  maps: 'Maps',
  byTerritory: 'Projects and Actions by Territory'
});

i18next.addResources('pt', 'map', {
  projects: 'Projetos e Ações',
  home: 'Início',
  maps: 'Mapas',
  byTerritory: 'Projetos e Ações por Território'
});
